/**
 * The browser's viewport is the area of the window in which web content can be seen.
 */
export interface ViewportDimensions {
    /**
     * The viewport width.
     */
    viewportWidth: number;
    /**
     * The viewport height.
     */
    viewportHeight: number;
}

/**
 * Get the current viewport dimensions.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/Viewport_concepts
 *
 * The document element's `Element.clientWidth` is the inner width of a document in CSS pixels,
 * including padding (but not borders, margins, or vertical scrollbars, if present). This is the viewport width.
 *
 * The `Window.innerWidth` is the width, in CSS pixels, of the browser window viewport including, if rendered, the vertical scrollbar.
 *
 * @param win window to measure - defaults to current window
 * @returns the current viewport dimensions
 */
export const getViewportDimensions = (win: Window = window): ViewportDimensions => ({
    viewportWidth: win.document.documentElement.clientWidth || win.innerWidth,
    viewportHeight: win.document.documentElement.clientHeight || win.innerHeight,
});
